/**
 * Bounce Checkout Redirect with Auto-Apply Discount
 * Intercepts checkout button clicks and applies discount code automatically
 */

class BounceCheckoutRedirect {
  constructor() {
    this.discountCookieName = 'bounce_discount_code';
    this.init();
  }

  init() {
    // Prevent execution in Theme Editor to allow page editing
    if (window.Shopify && window.Shopify.designMode) {
      return;
    }

    // Find all buttons that link to checkout
    const checkoutButtons = document.querySelectorAll('a[href="/checkout"]');

    checkoutButtons.forEach(button => {
      button.addEventListener('click', (e) => this.handleCheckoutClick(e));
    });
  }

  handleCheckoutClick(e) {
    e.preventDefault();

    // Get the discount code from cookie or current page
    const discountCode = this.getDiscountCode();

    if (discountCode) {
      // Redirect to checkout with auto-applied discount
      this.redirectToCheckout(discountCode);
    } else {
      // No discount code found, redirect to regular checkout
      // console.warn('No discount code found for auto-apply');
      window.location.href = '/checkout';
    }
  }

  getDiscountCode() {
    let code = null;

    // Try localStorage first (primary source - cookies removed)
    try {
      const couponData = localStorage.getItem('bounce_coupon_data');
      if (couponData) {
        const data = JSON.parse(couponData);
        code = data.code;

        // Validate not expired
        if (data.expiryTime && Date.now() < data.expiryTime) {
          return code;
        } else if (data.expiryTime) {
          console.warn('Discount code expired');
          return null;
        }
        // If no expiry time, return code anyway
        return code;
      }
    } catch (e) {
      console.warn('Could not read from localStorage');
    }

    // Fallback to DOM element
    const codeElement = document.getElementById('bounceCouponCode');
    if (codeElement && codeElement.textContent.trim()) {
      code = codeElement.textContent.trim();
      return code;
    }

    return null;
  }

  async redirectToCheckout(discountCode) {
    try {
      // First, fetch the current cart to ensure it's not empty
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      if (cart.item_count === 0) {
        // Cart is empty, show error and redirect to products page
        this.showError('Dein Warenkorb ist leer. Füge zuerst Produkte hinzu.');
        setTimeout(() => {
          window.location.href = '/collections/all';
        }, 2000);
        return;
      }

      // Cart has items, proceed to checkout with discount
      // Shopify's discount parameter format: /checkout?discount=CODEXXX
      const checkoutUrl = `/checkout?discount=${encodeURIComponent(discountCode)}`;

      // Track the checkout redirect
      this.trackCheckoutRedirect(discountCode, cart);

      // Redirect to checkout
      window.location.href = checkoutUrl;

    } catch (error) {
      console.error('Error checking cart:', error);
      // If cart check fails, still try to redirect
      window.location.href = `/checkout?discount=${encodeURIComponent(discountCode)}`;
    }
  }

  showError(message) {
    // Try to show error in existing error element
    const errorElement = document.getElementById('bounceCouponError');
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.style.display = 'block';
      return;
    }

    // Fallback: show alert
    alert(message);
  }

  getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  }

  trackCheckoutRedirect(discountCode, cart) {
    // Klaviyo tracking
    if (typeof _learnq !== 'undefined') {
      _learnq.push(['track', 'Started Checkout with Bounce Discount', {
        DiscountCode: discountCode,
        CartValue: (cart.total_price / 100).toFixed(2),
        CartItemCount: cart.item_count,
        Currency: cart.currency,
        Timestamp: new Date().toISOString()
      }]);
    }

    // Google Analytics
    if (typeof gtag !== 'undefined') {
      gtag('event', 'begin_checkout', {
        event_category: 'bounce_discount',
        event_label: discountCode,
        value: cart.total_price / 100,
        currency: cart.currency
      });
    }

    // Facebook Pixel
    if (typeof fbq !== 'undefined') {
      fbq('track', 'InitiateCheckout', {
        value: cart.total_price / 100,
        currency: cart.currency,
        content_name: 'Bounce Discount Checkout',
        discount_code: discountCode
      });
    }

    // console.log('Checkout redirect tracked:', discountCode);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new BounceCheckoutRedirect();
  });
} else {
  new BounceCheckoutRedirect();
}
